import { useAppDispatch, useAppSelector } from '~system/store/configure-store';
import { selectIsMobileMenuOpen } from '~system/store/mobile-menu/mobile-menu-selectors';
import { setIsOpen } from '~system/store/mobile-menu/mobile-menu-slice';

export const useMobileMenu = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsMobileMenuOpen);

  const openMenu = () => dispatch(setIsOpen(true));
  const closeMenu = () => dispatch(setIsOpen(false));
  const toggleMenu = () => dispatch(setIsOpen(!isOpen));

  return {
    isMenuOpen: isOpen,
    openMenu,
    closeMenu,
    toggleMenu,
  };
};
